import CreatePassword from "./CreatePassword";
export default CreatePassword;
